import { connect } from 'react-redux';
import {
  getCurrencyCode,
  getIsHotelOnly,
  getIsWebview,
} from 'src/store/view/selectors';
import { fetchHotelImagesAction } from 'src/store/hotelImages/sagaActions';
import { hotelImagesByIdSelector } from 'src/store/hotelImages/selectors';
import {
  getCashbackLabel,
  getCashbackLabelBackgroundColor,
  getCashbackLabelTextColor,
  getCashbackTooltip,
  getActivateCashbackForPartner,
  getCashbackIconWebp,
  getCashbackIconPng,
} from 'src/store/cashback/selectors';
import { getSearchParamsFromCountry } from 'src/store/enqueue/selectors';
import HotelRenderer from './HotelRenderer';
import { getIsViewed } from '../../selectors/viewedHotels';
import {
  getAdultsCount,
  getDepartureCity,
  getKidsAges,
  getKidsCount,
  getRequestId,
  isFlexDatesSelector,
} from '../../selectors/searchParams';
import { getOfferFilters } from '../../selectors/filters';
import { resetPopupData } from '../../store/map/slice';
import { setActiveHotelDataAction } from '../../store/map/sagaActions';

const mapStateToProps = (state, { id, images }) => ({
  currencyCode: getCurrencyCode(state),
  hotelPageVisited: getIsViewed(state, id),
  isFlexDates: isFlexDatesSelector(state),
  isHotelOnly: getIsHotelOnly(state),
  images: hotelImagesByIdSelector(state, id) || images,
  offerFilters: getOfferFilters(state),
  requestId: getRequestId(state),
  openInCurrentTab: getIsWebview(state),
  activateCashbackForPartner: getActivateCashbackForPartner(state),
  labelColor: getCashbackLabelBackgroundColor(state),
  textColor: getCashbackLabelTextColor(state),
  cashbackTooltipText: getCashbackTooltip(state),
  cashbackLabel: getCashbackLabel(state),
  cashbackIconWebp: getCashbackIconWebp(state),
  cashbackIconPng: getCashbackIconPng(state),
  adults: getAdultsCount(state),
  kids: getKidsCount(state),
  kidsAges: getKidsAges(state),
  fromCity: getDepartureCity(state)?.name_en || '',
  fromCountry: getSearchParamsFromCountry(state) || '',
});

const mapDispatchToProps = {
  getImages: fetchHotelImagesAction,
  resetPopupData,
  setActiveHotel: setActiveHotelDataAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(HotelRenderer);
